export default "__VITE_ASSET__lMW4TAfg__"